import Loader from '../../components/Shared/Loader';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpider } from '@fortawesome/free-solid-svg-icons';
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';

const NotFound = () => {
    const [loading, setLoading] = useState(false);
    const { user } = useAuth();

    return (
        <div className='overflow-hidden'>
            {loading && <Loader />}
            <div className="cardTotal d-flex align-items-center justify-content-center">
                <div className="card w-50">
                    <div className="container ">
                        <div className="card-body">
                            <div className="text-center">
                                <h1>404 <FontAwesomeIcon icon={faSpider} /></h1>
                                <h2>
                                    😓 Desculpe, página não encontrada!
                                </h2>
                                <p>
                                    Por favor tente novamente mais tarde ou
                                    entre em contato com o suporte através do email <a href='mailto:suporte.appleidobem@fi-group.com'>suporte.appleidobem@fi-group.com</a>
                                </p>
                                <h5><Link to={user ? '/home' : '/login'}>Sair</Link></h5>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}


export default NotFound;